<template>
  <div>
    <template v-if='recordList.length'>
      <div style='height: 160px;overflow-y:auto;'>
        <el-row>
          <div class='uk-flex uk-flex-between mb-10' v-for='item in recordList' :key='item.id'>

            <el-col :span='6'>
              <div style='white-space: nowrap;' class='mr-5'>
                {{ $timetransition(item.processTime) }}
              </div>
            </el-col>
            <el-col :span='14'>
              <div class='ellipsis  uk-text-center'>
                <Tooltip :text='item.reasonText' style='width: 300px;'>
                  <span>{{ item.reasonText }}</span>
                </Tooltip>
              </div>
            </el-col>

            <el-col :span='4'>
              <div style='white-space: nowrap;text-align: right'>
                {{ item.processor }}
                <i class='el-icon-document cursor-pointer'
                   :title="item.remark || $t('integration.no_comment_information')"></i>
              </div>
            </el-col>
          </div>
        </el-row>
      </div>

      <div class='uk-flex uk-flex-right'>
        <Pagination class='pagination' :total='total' :background='false'
                    :iDisplayLength='SearchForm.iDisplayLength' layout='prev, pager, next'
                    :page.sync='SearchForm.iDisplayStart' :limit.sync='SearchForm.iDisplayLength'
                    @pagination='getListFn'>
        </Pagination>
      </div>
    </template>
    <template v-else>
      <el-empty :image-size='100'></el-empty>
    </template>
  </div>
</template>

<script>
import { getExHandleRecordPage } from '@/api/modules/abnormal'
import Tooltip from '@/pages/system/resource/components/tooltip.vue'

export default {
  props: ['exId'],
  components: {
    Tooltip
  },
  data () {
    return {
      SearchForm: {
        iDisplayStart: 0,
        iDisplayLength: 5,
        exId: ''
      },
      recordList: [],
      total: 0
    }
  },
  watch: {
    exId: {
      handler () {
        this.SearchForm.exId = this.exId
        this.getListFn()
      },
      immediate: true
    }
  },
  methods: {
    getListFn () {
      getExHandleRecordPage(this.SearchForm).then(({
        result,
        pageInfo
      }) => {
        this.total = pageInfo.total

        this.recordList = result
      })
    }
  }
}
</script>
